<highcharts-chart #highchartsHook  style="width: 100%; height: 70vh; display: block;"
  [Highcharts]="highcharts"
  [options]="chartOptions"
  [(update)]="updateFlag"
  *ngIf="isShowPieChart">
</highcharts-chart>
